/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
// You can delete this file if you're not using it
export { default as wrapRootElement } from "./src/pages/ReduxWrapper";

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    import("./src/i18n/i18n").then(({ default: i18n }) => {
      const urlParams = new URLSearchParams(window.location.search);
      let lng = urlParams.get("lng");
      // clean lng parameter in case the format is lng=es/ because otherwise is trying to get the full es/ as a language
      if (lng && lng.endsWith("/")) {
        lng = lng.slice(0, -1);
        i18n.changeLanguage(lng);
      }
    });
  }
};
